module.exports = {"search":{"title":"Search","text":"Search","orderNo":"Order No.","drawingNo":"Drawing No.","customerName":"Customer Name","customerCode":"Customer Code","code":"Code","model":"Model","priority":"Priority","notFound":"Search Not Found","status":"Status","drawingRev":"Rev","coilSize":"Coil Size","pipeType":"Pipe type & Pattern","searchText":"Search","showLess":"Show Less","showAll":"Show All"}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/en/search.json
// module id = 536
// module chunks = 14